export default class Zone {
  constructor(
    zoneId = '',
    location = '',
    equipmentType = '',
    comment = '',
    eventId = '',
    signalReceived = false
  ) {
    this.zoneId = zoneId
    this.location = location
    this.equipmentType = equipmentType
    this.comment = comment
    this.eventId = eventId
    /* signalReceived is to always be initialized as false, and
       and set to true upon receiving matching event history
       on the signal test page */
    this.signalReceived = signalReceived
  }

  mapFromApi(responseData) {
    this.zoneId = responseData.ZoneId
    this.location = responseData.EquiplocId
    this.equipmentType = responseData.EquiptypeId
    this.comment = responseData.Comment
    this.eventId = responseData.ProcessingRules[0].EventId
    this.signalReceived = false
  }
}
